export default __webpack_public_path__ + "static/media/email.c0965664.svg";